import { useGetApiTimesheetsByUuidEntries, } from '../../generated/sitComponents';
/**
 * @deprecated This is not deprecrated, but each app should wrap this function and clearly define what to use for `variables.queryParams.includeAllocationChildren`
 */
export function useGetTimesheetEntries(variables, options) {
    return useGetApiTimesheetsByUuidEntries(variables, options);
}
//# sourceMappingURL=use-get-timesheet-entries.js.map